<template>
  <div>
    <!-- 人物信息 -->
    <img
      src="../assets/newImg/mobile/function1.png"
      class="function1"
      @click="roleFlag = true"
    />
    <transition
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOutLeft"
    >
      <Role v-if="roleFlag" @close="roleFlag = false" />
    </transition>

    <transition
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <Roam v-if="roamFlag" @close="roamFlag = false" />
    </transition>
    <!-- 右侧菜单 -->
    <div class="rightFuntion">
      <div
        v-for="(item, index) in rightFunction"
        :key="index"
        @click="fun(index)"
        style="margin-right: 20px"
      >
        <img :src="item.i" />
        <p>{{ item.f }}</p>
      </div>
    </div>
    <!-- 换装 -->
    <transition
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOutLeft"
    >
      <Change v-if="changeFlag" @close="changeFlag = false" />
    </transition>

    <!-- 动作 -->

    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <Action v-if="actionFlag" />
    </transition>
  </div>
</template>

<script>
import Role from "./role.vue";
import Change from "./change.vue";
import Action from "./action.vue";
import Roam from "./roam.vue";
export default {
  data() {
    return {
      roleFlag: false,
      roamFlag: false,
      changeFlag: false,
      actionFlag: false,
      //右侧菜单
      rightFunction: [
        {
          i: require("../assets/newImg/mobile/function2.png"),
          f: "全屏",
        },

        {
          i: require("../assets/newImg/mobile/function3.png"),
          f: "皮肤",
        },

        {
          i: require("../assets/newImg/mobile/function4.png"),
          f: "服务漫游",
        },
        {
          i: require("../assets/newImg/mobile/function5.png"),
          f: "动作",
        },
      ],
    };
  },
  components: {
    Role,
    Change,
    Action,
    Roam,
  },
  methods: {
    fun(e) {
      console.log(e);

      if (e == 0) {
        if (navigator.userAgent.match(/iPhone/i)) {
          this.$message.error("当前浏览器不支持全屏");
        }
        var el = document.documentElement;
        var isFullscreen =
          document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
        console.log(isFullscreen);
        if (!isFullscreen) {
          //进入全屏,多重短路表达式
          (el.requestFullscreen && el.requestFullscreen()) ||
            (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
            (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) ||
            (el.msRequestFullscreen && el.msRequestFullscreen());
        } else {
          //退出全屏,三目运算符
          document.exitFullscreen
            ? document.exitFullscreen()
            : document.mozCancelFullScreen
            ? document.mozCancelFullScreen()
            : document.webkitExitFullscreen
            ? document.webkitExitFullscreen()
            : this.$message.error("当前浏览器不支持全屏");
        }
      }
      if (e == 1) {
        if (document.o2.role.state == "sit") {
          this.$message.error("坐下无法换装");
          return;
        }
        this.changeFlag = true;
      }

      if (e == 2) {
        this.roamFlag = !this.roamFlag;
      }

      if (e == 3) {
        this.actionFlag = !this.actionFlag;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.function1 {
  position: absolute;
  top: 14px;
  left: 11px;
}
.rightFuntion {
  top: 14px;
  right: 11px;
  display: flex;
  position: absolute;

  img {
  }

  p {
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    text-shadow: 0px 3px 4px 0px rgba(33, 58, 139, 0.92);
    text-align: center;
    margin-top: 5px;
  }
}
</style>
